import {
  collection,
  query,
  orderBy,
  onSnapshot,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  limit,
} from 'firebase/firestore';
import { getFirestoreDb } from './config';
import { LEAD_STATUS } from './leads';

export { LEAD_STATUS };

export function getLeadDate(lead) {
  const t = lead.createdAt;
  if (t && typeof t.toDate === 'function') return t.toDate();
  if (lead.createdAt?._seconds) {
    return new Date(lead.createdAt._seconds * 1000);
  }
  if (lead.timestamp?.toDate) return lead.timestamp.toDate();
  return null;
}

/**
 * Real-time all leads (newest first). Caller must check isFirebaseConfigured().
 */
export function subscribeLeads(callback, onError) {
  const db = getFirestoreDb();
  if (!db) {
    onError?.(new Error('Firestore not available'));
    return () => {};
  }
  const q = query(collection(db, 'leads'), orderBy('createdAt', 'desc'), limit(500));
  return onSnapshot(
    q,
    (snap) => {
      const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      callback(rows);
    },
    (err) => onError?.(err)
  );
}

export async function updateLeadStatus(leadId, status) {
  const db = getFirestoreDb();
  if (!db) throw new Error('Firestore not available');
  await updateDoc(doc(db, 'leads', leadId), {
    status,
    updatedAt: serverTimestamp(),
  });
}

export async function updateLeadTags(leadId, tags) {
  const db = getFirestoreDb();
  if (!db) throw new Error('Firestore not available');
  await updateDoc(doc(db, 'leads', leadId), {
    tags: Array.isArray(tags) ? tags : [],
    updatedAt: serverTimestamp(),
  });
}

export async function deleteLeadById(leadId) {
  const db = getFirestoreDb();
  if (!db) throw new Error('Firestore not available');
  await deleteDoc(doc(db, 'leads', leadId));
}

export function leadsToCsv(rows) {
  const headers = [
    'id',
    'name',
    'phone',
    'email',
    'status',
    'source',
    'createdAt',
    'message',
    'tags',
  ];
  const lines = [headers.join(',')];
  for (const r of rows) {
    const created = getLeadDate(r);
    const esc = (v) => {
      const s = String(v ?? '').replace(/"/g, '""');
      return `"${s}"`;
    };
    lines.push(
      [
        esc(r.id),
        esc(r.name),
        esc(r.phone),
        esc(r.email),
        esc(r.status),
        esc(r.source),
        esc(created ? created.toISOString() : ''),
        esc(r.message),
        esc(Array.isArray(r.tags) ? r.tags.join(';') : r.tags || ''),
      ].join(',')
    );
  }
  return lines.join('\n');
}
